import ResponsiveDialog from "@/features/ResponsiveDialog/ResponsiveDialog";
import DialogCloseBtn from "@/features/ResponsiveDialog/styled/DialogCloseBtn";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDateTimePicker } from "@mui/x-date-pickers/StaticDateTimePicker";
import { Dayjs } from "dayjs";
import { FlexColumnAlignJustifyCenter } from "./Flex";
import { themeColors } from "@/utils/themeColors";

const DateTimePickerPopup = ({
    isOpen,
    onClose,
    value,
    onChange,
    onAccept: _onAccept,
}: {
    isOpen: boolean;
    onClose: () => void;
    value: Dayjs | null;
    onChange?: (value: Dayjs | null) => void;
    onAccept: (value: Dayjs | null) => void;
}) => {
    const onAccept = (value: Dayjs | null) => {
        _onAccept(value);
        onClose();
    };

    const renderDateTimePickerContent = () => (
        <FlexColumnAlignJustifyCenter style={{ height: "100%", width: "100%" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDateTimePicker
                    orientation="landscape"
                    value={value}
                    disablePast
                    onChange={onChange}
                    onAccept={onAccept}
                    slotProps={{ actionBar: { actions: ["accept"] } }}
                    sx={{
                        backgroundColor: themeColors.neutralWhite,
                        color: themeColors.neutralBlack,
                        "& .MuiPickersDay-root": { fontSize: "1.4rem" },
                        "& .MuiInputBase-root": { fontSize: "1.4rem" },
                        "& .MuiButtonBase-root": { fontSize: "1.4rem", color: themeColors.neutralBlack },
                        "& .MuiPickersCalendarHeader-labelContainer": { fontSize: "1.4rem" },
                        "& .MuiPickersLayout-root": { fontSize: "1.4rem" },
                        "& .MuiSvgIcon-root": { height: "2.4rem", width: "2.4rem" },
                        "& .MuiDayCalendar-weekDayLabel": { fontSize: "1.4rem" },
                        "& .MuiPickersYear-yearButton": { fontSize: "1.4rem" },
                        "& .MuiClock-clock": { backgroundColor: "transparent" },
                        "& .MuiTypography-overline": { fontSize: "1.4rem" },
                        "& .MuiTypography-subtitle1": { fontSize: "1.4rem" },
                        "& .MuiPickersToolbar-content": { gap: "1rem" },
                        "& .MuiTypography-root": { color: themeColors.neutralBlack },
                        "& .MuiPickersDay-root.Mui-selected": { backgroundColor: themeColors.primary },
                        "& .MuiTabs-indicator": { backgroundColor: themeColors.primary },
                        "& .MuiClock-pin": { backgroundColor: themeColors.primary },
                        "& .MuiClockPointer-root": { backgroundColor: themeColors.primary },
                        "& .MuiClockPointer-thumb": {
                            backgroundColor: themeColors.primary,
                            borderColor: themeColors.primary,
                        },
                    }}
                />
            </LocalizationProvider>
        </FlexColumnAlignJustifyCenter>
    );

    return (
        <ResponsiveDialog
            isOpen={isOpen}
            onClose={onClose}
            DialogProps={{
                scroll: "body",
                classes: { paper: "hide-scrollbar" },
            }}
            DialogStyle={{
                boxSizing: "content-box",
                borderRadius: "4rem",
                maxWidth: "100rem",
                width: "60rem",
                height: "fit-content",
                transition: "width 0.2s ease-in-out, height 0.2s ease-in-out",
                padding: "4rem",
            }}
            SlideMenuStyle={{ padding: "2.47rem 2rem 2rem 2rem" }}>
            <DialogCloseBtn
                onClick={onClose}
                forDialogStyle={{ marginLeft: "auto" }}
                forSlideMenuStyle={{ marginLeft: "auto", marginBottom: "2rem" }}
            />
            {renderDateTimePickerContent()}
        </ResponsiveDialog>
    );
};

export default DateTimePickerPopup;
